import React, { useContext, useState, useMemo } from 'react';
import { DynamicComponent } from '@thd-nucleus/app-render';
import { QueryContext } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { LayoutGroup } from '@thd-olt-component-react/layout-manager';
import { string, arrayOf, shape } from 'prop-types';
import classNames from 'classnames';
import {
  KitchenCollectionProductsLoad,
  KitchenCollectionProducts
} from '../dynamic-imports';
import { KitchenCollectionDataModel } from '../KitchenCollectionDataModel';
import { ProductsPlaceholder } from './placeholder/ProductsPlaceholder';
import { KitchenCollectionSectionHeading } from './KitchenCollectionSectionHeading';

export const KitchenCollectionSection = ({
  channel,
  section
}) => {
  const qctx = useContext(QueryContext);
  const [productCount, setProductCount] = useState(null);
  const collectionSectionStyle = classNames({
    'kitchen-collection__products': productCount == null || productCount > 0
  });
  return (
    <div className={collectionSectionStyle}>
      {productCount > 0 && (
        <KitchenCollectionSectionHeading sectionTitle={section.title} productCount={productCount} />
      )}
      <DynamicComponent pageType="collection">
        <Hydrator
          id={`collection-products-section__${section.title}`}
          delay={1000}
          scrollBuffer={400}
          preserveCtxVal="clientStore"
          waitFor={KitchenCollectionProductsLoad}
          placeholder={(
            <ProductsPlaceholder />
          )}
        >
          <LayoutGroup name="Products">
            <KitchenCollectionProducts
              channel={channel}
              itemIds={section.products.map((prod) => prod.itemId)}
              setProductCount={setProductCount}
              qctx={qctx}
            />
          </LayoutGroup>
        </Hydrator>
      </DynamicComponent>
    </div>
  );
};

KitchenCollectionSection.displayName = 'KitchenCollectionSection';

KitchenCollectionSection.dataModel = KitchenCollectionDataModel;

KitchenCollectionSection.propTypes = {
  channel: string.isRequired,
  section: shape({
    title: string,
    products: arrayOf(shape({
      itemId: string
    }))
  }).isRequired
};